import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

interface HlMessage {
  message: string;
  userType: string;
}

@Pipe({
  name: 'hlSafeMessage',
})
export class HlSafeMessagePipe implements PipeTransform {
  private static readonly ALLOWED_INLINE_STYLE_PROPERTIES = ['text-align', 'white-space'];

  constructor(private sanitizer: DomSanitizer) {}

  transform(message: HlMessage): SafeHtml | string {
    if (message.userType === 'customer') {
      return message.message;
    }
    return this.sanitizer.bypassSecurityTrustHtml(this.restrictInlineStyles(message.message));
  }

  // Some outbound messages embed HTML sourced from email templates (e.g. a "View Full
  // Conversation" CTA button) whose inline styles aren't meant for the HIL thread view.
  // Only alignment/whitespace formatting from the original disclaimer should carry over.
  private restrictInlineStyles(html: string): string {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    parsed.body.querySelectorAll<HTMLElement>('[style]').forEach(el => {
      const allowedDeclarations = HlSafeMessagePipe.ALLOWED_INLINE_STYLE_PROPERTIES.map(
        property => el.style.getPropertyValue(property) && `${property}: ${el.style.getPropertyValue(property)}`,
      ).filter(Boolean);

      if (allowedDeclarations.length) {
        el.setAttribute('style', allowedDeclarations.join('; '));
      } else {
        el.removeAttribute('style');
      }
    });
    return parsed.body.innerHTML;
  }
}
